{
  "breadcrumb": {
    "path": "databases > clientes >",
    "all": "Todos"
  },
  "timeRanges": {
    "all": "Todo",
    "today": "Hoy",
    "15days": "15 días",
    "1month": "1 mes",
    "3months": "3 meses",
    "6months": "6 meses",
    "1year": "Un año"
  },
  "table": {
    "columns": {
      "producto": "Producto",
      "industria": "Industria",
      "fecha": "Fecha",
      "estatus": "Estatus",
      "cliente": "Cliente",
      "transaccion": "Transacción",
      "oper": "Oper"
    },
    "addButton": "Agregar operación",
    "searchPlaceholder": "Buscar operaciones...",
    "searchAriaLabel": "Buscar operaciones",
    "clearSearchAriaLabel": "Limpiar búsqueda",
    "prevDateAriaLabel": "Fecha anterior",
    "nextDateAriaLabel": "Fecha siguiente",
    "timeRangeAriaLabel": "Rango de tiempo",
    "dateAriaLabel": "Fecha",
    "noPermission": "No tienes permisos para ver las operaciones de esta pestaña.",
    "loading": "Cargando...",
    "emptyNoOps": "Sin operaciones",
    "emptyNoOpsFor": "Sin operaciones para \"{{search}}\"",
    "selectRowAriaLabel": "Seleccionar {{name}}",
    "archiveConfirm": "¿Estás seguro de que deseas archivar este cliente? Desaparecerá de todas las listas.",
    "archiveTitle": "Archivar / Borrar",
    "archiveAriaLabel": "Archivar {{name}}",
    "operationFallback": "operación"
  },
  "permissions": {
    "searchPlaceholder": "Buscar usuario...",
    "searchAriaLabel": "Buscar usuario",
    "admin": "Admin"
  },
  "wizard": {
    "industryPlaceholder": "Industria...",
    "industryAriaLabel": "Industria",
    "clientSearchPlaceholder": "Buscar cliente...",
    "clientSearchAriaLabel": "Buscar cliente",
    "addClient": "+ Agregar \"{{name}}\"",
    "fullNamePlaceholder": "Nombre completo",
    "emailPlaceholder": "Correo electrónico",
    "cancel": "Cancelar",
    "create": "Crear",
    "establishmentPlaceholder": "NOMBRE DEL RESTAURAN O del establecimiento...",
    "establishmentAriaLabel": "Nombre del establecimiento",
    "assignOperatorPlaceholder": "Asignar operador...",
    "assignOperatorAriaLabel": "Asignar operador",
    "back": "Regresar",
    "cancelWizard": "Cancelar",
    "createUserError": "Error al crear usuario"
  },
  "addModal": {
    "title": "+ Nueva Operación",
    "transactionTitlePlaceholder": "Título de la operación *",
    "transactionTitleAriaLabel": "Título de la operación",
    "transactionRequired": "El título de la operación es obligatorio",
    "categoryAriaLabel": "Categoría",
    "statusAriaLabel": "Estatus",
    "totalAmountPlaceholder": "Monto total",
    "totalAmountAriaLabel": "Monto total",
    "currencyAriaLabel": "Moneda",
    "costPlaceholder": "Costo",
    "costAriaLabel": "Costo",
    "salePricePlaceholder": "Precio venta",
    "salePriceAriaLabel": "Precio venta",
    "operationTimePlaceholder": "Tiempo de operación",
    "operationTimeAriaLabel": "Tiempo de operación",
    "priceTextPlaceholder": "Precio (texto, ej: 2.5%)",
    "priceTextAriaLabel": "Precio (texto)",
    "spaceAriaLabel": "Space",
    "spaceDefaultOption": "{{name}} (activo)",
    "cancel": "Cancelar",
    "save": "Guardar"
  },
  "cosmic": {
    "kpis": {
      "generalBalance": "Bolsa General",
      "currentBalance": "Saldo Actual",
      "activeLines": "Líneas Activas",
      "operatingLines": "Líneas Operando",
      "suspended": "Suspendidas",
      "needsAttention": "Requieren atención",
      "inventory": "Inventario",
      "inactiveChips": "Chips inactivos",
      "history": "Historial",
      "operations": "Operaciones"
    },
    "actions": {
      "newActivation": "Nueva Activación",
      "recharge": "Recarga",
      "portability": "Portabilidad"
    },
    "historyTable": {
      "date": "Fecha",
      "line": "Línea",
      "description": "Descripción",
      "event": "Evento",
      "empty": "No hay eventos recientes"
    },
    "linesTable": {
      "line": "Línea",
      "titular": "Titular",
      "plan": "Plan",
      "status": "Estado",
      "date": "Fecha",
      "consumption": "Consumo",
      "action": "Acción",
      "empty": "No se encontraron líneas",
      "noName": "Sin nombre",
      "noPlan": "Sin plan",
      "inactive": "INACTIVA",
      "activeStatus": "Activo",
      "loadingDate": "Cargando fecha...",
      "days": "días",
      "gbLeft": "GB rest",
      "messagesAriaLabel": "Mensajes",
      "moreActionsAriaLabel": "Más acciones"
    },
    "pagination": {
      "previous": "Anterior",
      "next": "Siguiente",
      "page": "Página {{current}} de {{total}}"
    }
  },
  "cosmicClient": {
    "titles": {
      "newActivation": "Nueva Activación",
      "recharge": "Recarga",
      "portability": "Portabilidad"
    },
    "noName": "Sin nombre",
    "messageTooltip": "Mensaje",
    "rechargeButton": "Realizar Recarga",
    "tabForm": "Formulario",
    "tabClient": "Cliente",
    "noNumber": "Sin número",
    "clientSince": "Cliente desde el",
    "lifecycle": {
      "prospect": "Prospecto",
      "lineShipping": "Envio de linea",
      "active": "Activo",
      "portability": "Portabilidad",
      "debt": "Deuda",
      "preDeactivation": "Predesactivacion",
      "deactivated": "Desactivado"
    },
    "currentPlan": "Plan actual",
    "perMonth": "/ mes",
    "renewal": "Renovación",
    "nextMonth": "Próximo mes",
    "monthlyConsumption": "Consumo del mes",
    "data": "Datos",
    "minutes": "Minutos",
    "sms": "SMS",
    "unlimited": "Ilimitados",
    "commentsTitle": "Comentarios del Cliente"
  },
  "cosmicPurchases": {
    "title": "Recargar saldo",
    "subtitle": "Recarga saldo a un número de nuestro ecosistema.",
    "numberLabel": "Número a recargar",
    "numberPlaceholder": "Ingresa los 10 dígitos",
    "planLabel": "Elige un paquete",
    "successTitle": "Recarga con éxito",
    "successMessage": "El saldo ha sido aplicado a la línea.",
    "close": "Cerrar",
    "errorTitle": "Estamos experimentando problemas",
    "errorMessage": "Por favor, intenta de nuevo más tarde.",
    "retry": "Reintentar",
    "totalToPay": "Total a pagar",
    "processing": "Procesando...",
    "recharge": "Recargar"
  },
  "detailPanel": {
    "copyLinkTitle": "Copiar enlace",
    "operationFallback": "Operación",
    "closeAriaLabel": "Cerrar",
    "tabs": {
      "flow": "Flow",
      "config": "Configuración",
      "comments": "Comentarios"
    },
    "comments": {
      "placeholder": "Escribe un comentario...",
      "send": "Enviar",
      "empty": "Sin comentarios todavía",
      "unknownUser": "Usuario"
    },
    "whatsappPanelTitle": "WhatsApp Panel",
    "flowMenu": {
      "client": "Cliente",
      "structure": "Estructura",
      "operator": "Oper",
      "document": "Documento",
      "trigger": "Trigger",
      "stage": "Etapa"
    },
    "flowSearchPlaceholder": "Buscar...",
    "flowDropdownSearchAriaLabel": "Buscar en el menú del flujo",
    "flowAdd": "+ Anadir",
    "flowSearchAriaLabel": "Buscar nodo en el flujo",
    "runFlowTitle": "Ejecutar flujo",
    "deleteNodeTitle": "Eliminar",
    "deleteNodeAriaLabel": "Eliminar nodo",
    "editNodeTitle": "Editar",
    "editNodeAriaLabel": "Editar nodo",
    "configPlaceholder": "Configuración",
    "comingSoon": "Próximamente"
  },
  "industryInput": {
    "ariaLabel": "Industria de la operación"
  }
}
